module.exports = __webpack_public_path__ + "static/media/children.ac8098be.jpg";